import { withAsync } from '@/components/Async'
import React from 'react'
import type { RouteConfig } from 'react-router-config'
import { Redirect } from 'react-router'
import Blank from '@/layouts/Blank'
import { withAddressSplitAlgorithmTrackPage } from '@/bizComponents/AddressAutoSplit/AddressSplitAlgorithmTrack'

const routes: RouteConfig[] = [
  {
    path: '/logistics',
    name: 'logistics',
    component: Blank,
    permissionCode: 'ship:logistics',
    routes: [
      {
        name: 'logisticsList',
        path: '/list',
        component: withAsync(() => import(/* webpackChunkName: "logisticsList" */ '@/containers/Logistics/List')),
        exact: true,
        main: true,
      },
      {
        name: 'detail',
        path: '/detail/:appId/:logisticsNo',
        component: withAsync(() => import(/* webpackChunkName: "logisticsDetail" */ '@/containers/Logistics/Detail')),
        exact: true,
      },
      {
        name: 'edit',
        path: '/edit/:appId/:logisticsNo',
        component: withAddressSplitAlgorithmTrackPage(
          withAsync(() => import(/* webpackChunkName: "logisticsEdit" */ '@/containers/Logistics/Edit')),
          'logisticsEdit'
        ),
        exact: true,
      },
      {
        path: '/',
        component() {
          return <Redirect to="/ship/logistics/list" />
        },
        exact: true,
      },
    ],
  },
]

export default routes
